module.exports = __webpack_public_path__ + "img/executor.2eb1a884.svg";